import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CompletedComponent } from './completed/completed.component';
import { ErrorComponent } from './error/error.component';
import { FormComponentComponent } from './form-component/form-component.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { TrackingComponent } from './tracking/tracking.component';
import { TrackingDetailComponent } from './tracking/tracking-detail/tracking-detail.component';

const routes: Routes = [
	{
		'path': 'completed/:formID',
		'component': CompletedComponent
	},
	{
		'path': 'error/:formID',
		'component': ErrorComponent
	},
	{
		'path': 'not-found',
		'component': NotFoundComponent
	},
	{
		'path': 'tracking/:formID/detail/:trackingId',
		'component': TrackingDetailComponent
	},
	{
		'path': 'tracking/:formID',
		'component': TrackingComponent
	},
	{
		'path': ':formID',
		'component': FormComponentComponent
	},
	{ path: '**', redirectTo: ':formId', },
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }

